<template>
    <span v-tooltip.left="tooltipContent">
        <el-select v-model="selectedFleet" placeholder="Sélectionner une base" class="select-group" filterable
            @change="changeSelectedFleet">
            <el-option v-for="group in groups" :key="group.uid" :label="group.name" :value="group.uid">
            </el-option>
        </el-select>
    </span>
</template>

<script>
import schwartz from 'schwartz';
import { mapGetters } from 'vuex';

export default {

    data() {
        return {
            groups: [],
            selectedFleet: '',
            tooltipContent: 'Sélectionner la base que vous souhaitez gérer.',
        };
    },

    computed: {
        ...mapGetters([
            'getUserGroups',
            'isBridgestoneUser',
            'getSelectedFleet',
            'getVehicleInspectionStatus',
        ]),
    },

    mounted() {
        if (this.isBridgestoneUser) {
            this.groups = this.filterArrayWithSchwartz(this.$store.getters.groups);
        } else {
            this.groups = this.filterArrayWithSchwartz(this.getUserGroups(this.$store.getters.currentUser.uid));
        }
        this.selectedFleet = this.getSelectedFleet;
    },

    methods: {
        changeSelectedFleet() {
            this.$store.dispatch('setSelectedFleetForDataDisplay', this.selectedFleet);
            this.$store.dispatch('remoteGet', {
                url: '/vehicle/stats/?out_of_fleet=false&client_group=' + this.selectedFleet
            }).then((response) => {
                this.$store.dispatch('setNumberVehiclesToInspect', response.data.objects_count);
            });
            this.$store.dispatch('remoteGet', {
                url: '/vehicle/?&out_of_fleet=false&client_group=' + this.selectedFleet
            }).then((response) => {
                let extremeResults = response.data.results.filter(
                    vehicle => this.getVehicleInspectionStatus(vehicle).toLowerCase() === 'extreme'
                );
                this.$store.dispatch('setExtremeVehiculesInspectionCount', extremeResults.length);
            });
            this.$store.dispatch('remoteGet', {
                url: '/inspection-request/stats/?archived=false&client_has_answered=false&client_group='
                    + this.selectedFleet
            }).then((response) => {
                this.$store.dispatch('setNumberRequests', response.data.objects_count);
            });
        },

        filterArrayWithSchwartz(array) {
            return schwartz(array, (item) => { return item.verbose_name; });
        },
    },
};
</script>

<style lang="scss">
.select-group {
    width: 350px;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/select-group.vue